const DB_NAME = 'findify-kiosk-offline';
const STORE_NAME = 'snapshots';
const SNAPSHOT_KEY = 'workspace';

const openDatabase = (): Promise<IDBDatabase> =>
  new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () =>
      request.result.createObjectStore(STORE_NAME);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

export const readOfflineSnapshot = async (): Promise<any | undefined> => {
  if (typeof indexedDB === 'undefined') return undefined;
  const db = await openDatabase();
  return new Promise(resolve => {
    const request = db
      .transaction(STORE_NAME, 'readonly')
      .objectStore(STORE_NAME)
      .get(SNAPSHOT_KEY);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => resolve(undefined);
  });
};

export const writeOfflineSnapshot = async (value: any) => {
  if (typeof indexedDB === 'undefined') return;
  const db = await openDatabase();
  await new Promise<void>((resolve, reject) => {
    const request = db
      .transaction(STORE_NAME, 'readwrite')
      .objectStore(STORE_NAME)
      .put(value, SNAPSHOT_KEY);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};
